<template>
  <div ref="container">
    <!-- @slot Content to be lazy loaded -->
    <slot v-if="show"></slot>
  </div>
</template>
<script>
export default {
  props: {
    /**
     * Number of milliseconds in delaying the observer
     */
    delay: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio > 0) {
                this.show = true;
                observer.unobserve(this.$refs.container);
              }
            });
          },
          {
            threshold: 0.01,
          },
        );

        if (this.delay) {
          setTimeout(() => observer.observe(this.$refs.container), this.delay);
        } else {
          observer.observe(this.$refs.container);
        }
      } else {
        this.show = true;
      }
    });
  },
};
</script>
<style lang="postcss"></style>
